/**
 * [description]
 * @param  {[type]} array [description]
 * @param  {[type]} value [description]
 * @param  {[type]} index [description]
 * @return {[type]}       [description]
 */
export let unique = (array, property) => {
    var processed = [];

    for (var i = array.length - 1; i >= 0; i--) {
        if (array[i].hasOwnProperty(property)) {
            if (processed.indexOf(array[i][property]) < 0) {
                processed.push(array[i][property]);
            } else {
                array.splice(i, 1);
            }
        }
    }

    return array;
};